import { Pipe, PipeTransform } from '@angular/core';
import { ApprovalType } from '../enums/approval-type.enum';

@Pipe({
  name: 'approvalStatus',
  standalone: false,
})
export class ApprovalStatusPipe implements PipeTransform {
  transform(value: number | undefined): string {
    if (value == null) return '';

    return ApprovalType[value];
  }
}
